import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'scheduleFilter'
})
export class ScheduleFilterPipe implements PipeTransform {
    transform(items: any[], field: string, value: any): any[] {
        if (!items || !field || value == null) {
            return items;
        }

        return items.filter(item => item[field]?.toString() === value.toString());
    }
}
